import { PagedAndSortedResultRequestDto, PagedResultDto, RestService } from '@abp/ng.core';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateLeadConcentDocumentDto, CRMDocumentResponseDto, InserAttechDocumentDto, LeadUsingTemplateTitleAndUpalodTypeDto, SendUploadedDocumentForSignDto, UploadSingedDocumentDto } from 'projects/crm-services/src/lib/proxy/crmservice/documents/models';
import { CreateNoteDto, UpdateNoteDto } from 'projects/crm-services/src/lib/proxy/crmservice/note/models';
import { Observable } from 'rxjs';
import { AddressKeyService } from '../shared/service/addresskey.service';
import { CreateTemplateDocumentDto } from 'projects/crm-services/src/lib/proxy/crmservice/template-documents';
import { EmailDraftDto } from 'projects/crm-services/src/lib/proxy/crmservice/email-drafts';

interface documentStorageDTO {
  UploadDocumentstorageType: number;
  AccessToken: String;
  UserId: number;
}

interface storageFolderNameDTO {
  FolderName: String;
}

interface createProfilePictureDto {
  type: number,
  ImageContent: any
}

interface postProfilePassowordDTO {
  currentPassword: string,
  newPassword: string
}

interface ColorConfigurationSetting {
  primaryColor: string;
  secondaryColor: string;
  sidebarColor: string;
  sidebarMenuTextColor: string;
  isPrimaryGradient: boolean;
  primaryGradientColor: string;
}

@Injectable({
  providedIn: "root",
})
export class CustomService {
  postDocumentStorage = (input: documentStorageDTO) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: "/api/setting-management/DocumentStorage",
        body: input,
      },
      { apiName: "default" }
    );

  getDocumentStorage = () =>
    this.restService.request<any, boolean>(
      {
        method: "GET",
        url: `/api/setting-management/DocumentStorage`,
      },
      { apiName: "Default" }
    );

  createleadConsentDocumentService = (
    file: File,
    input: CreateLeadConcentDocumentDto
  ) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: "/api/crm-service/document",
        body: this.generateDocumentation(file, input),
      },
      { apiName: "Default" }
    );

  private generateDocumentation(file, input) {
    const formData = new FormData();
    if (file != null) {
      formData.append("leadId", "" + input.leadId);
      formData.append("documentType", input.documentType);
      formData.append("documentName", "documentName");
      formData.append("year", input.year);
      formData.append("iFileProvider", file, file.name);
      formData.append("signedDate", input.signedDate);
      formData.append("reason", input.reason);
      formData.append("email", input.email);
      if (input?.submittedDate) {
        formData.append("submittedDate", input.submittedDate);
      }
      if (input?.agentOfRecord) {
        formData.append("agentOfRecord", input.agentOfRecord);
      }
      if (input?.agencyId) {
        formData.append("agencyId", input.agencyId);
      }
      if (input?.languages) {
        formData.append("languages", input.languages);
      }
      if (input.consentId != null) {
        formData.append("consentId", input.consentId);
      }
      if (input.proposalId != null) {
        formData.append("proposalId", input.proposalId);
      }
    }
    return formData;
  }

  getStoragefolderName = () =>
    this.restService.request<any, boolean>(
      {
        method: "GET",
        url: `/api/setting-management/GetFolderName`,
      },
      { apiName: "Default" }
    );

  postStorageFolderName = (input: storageFolderNameDTO) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: "/api/setting-management/SetFolderName",
        body: input,
      },
      { apiName: "default" }
    );

  createSendConsentDocumentService = (
    file: File,
    input: UploadSingedDocumentDto
  ) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: "/api/crm-service/document/upload-signed-document",
        body: this.generateSendDocumentation(file, input),
      },
      { apiName: "Default" }
    );

  private generateSendDocumentation(file, input) {
    const formData = new FormData();
    if (file != null) {
      formData.append("leadId", "" + input.leadId);
      formData.append("iFileProvider", file, file.name);
    }
    return formData;
  }
  createAgentProfileService = (file: File, agencyFile: File, input: any) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: "/api/crm-service/agent-profile",
        body: this.generateAgentProfile(file, agencyFile, input),
      },
      { apiName: "Default" }
    );
  updateAgentProfileService = (
    id: any,
    file: File,
    agencyFile: File,
    input: any
  ) =>
    this.restService.request<any, boolean>(
      {
        method: "PUT",
        url: `/api/crm-service/agent-profile/${id}`,
        body: this.generateAgentProfile(file, agencyFile, input),
      },
      { apiName: "Default" }
    );
  private generateAgentProfile(file, agencyFile, input: any) {
    const formData = new FormData();
    formData.append("userName", input.userName);
    if (file != null) {
      formData.append("iFileProvider", file, file.name);
    }
    if (agencyFile != null) {
      formData.append("iFileProviderAgencyLogo", agencyFile, agencyFile.name);
    }
    formData.append("aboutContext", input.aboutContext);
    formData.append("videoURL", input.videoURL);
    if (input.agencyName != null) {
      formData.append("agencyName", input.agencyName);
    }

    if (input.agencyNPN != null) {
      formData.append("agencyNPN", input.agencyNPN);
    }
    if (input.agencyPhoneNumber != null) {
      formData.append("agencyPhoneNumber", input.agencyPhoneNumber);
    }
    if (input.agencyEmail != null) {
      formData.append("agencyEmail", input.agencyEmail);
    }
    if (input.agencyAddress != null) {
      formData.append("agencyAddress", input.agencyAddress);
    }

    if (input.socialMedia && input.socialMedia.length > 0) {
      input.socialMedia.forEach((socialMediaItem, index) => {
        formData.append(
          `socialMedia[${index}].platform`,
          socialMediaItem.platform
        );
        formData.append(`socialMedia[${index}].url`, socialMediaItem.url);
      });
    }
    return formData;
  }

  getMyProfile = () =>
    this.restService.request<any, boolean>(
      {
        method: "GET",
        url: "/api/identity-server/custom-profile/custom-profile",
      },
      { apiName: "default" }
    );

  sendOTPForEmailChange = (input: any) =>
    this.restService.request<any, any>({
      method: 'POST',
      url: '/api/identity-server/custom-profile/send-user-email-otp',
      body: input,
    },
      { apiName: 'default' }
    );

  verifyOTPForEmailChange = (input: any) =>
    this.restService.request<any, any>({
      method: 'POST',
      url: '/api/identity-server/custom-profile/verify-email-change-code',
      body: input,
    },
      { apiName: 'default' }
    );

  getProfilePicture = (id: any) =>
    this.restService.request<any, boolean>(
      {
        method: "GET",
        url: `/api/identity-server/custom-profile-picture/${id}/profile-picture`,
      },
      { apiName: "default" }
    );

  createProfilePicture = (input: createProfilePictureDto, data: File) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: "/api/identity-server/custom-profile-picture/set-profile-picture",
        body: this.generateProfilePhotoInput(input, data),
      },
      { apiName: "default" }
    );

  private generateProfilePhotoInput(input: createProfilePictureDto, data) {
    const formData = new FormData();
    if (data != null) {
      formData.append("type", "" + input.type);
      formData.append("ImageContent", data[0], data[0].name);
    } else {
      formData.append("type", "" + input.type);
      formData.append("ImageContent", "");
    }
    return formData;
  }

  postProfilePassoword = (input: postProfilePassowordDTO) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: "/api/identity-server/custom-change-password/custom-change-password",
        body: input,
      },
      { apiName: "default" }
    );

  getColorConfigurationSetting = () =>
    this.restService.request<any, ColorConfigurationSetting>(
      {
        method: "GET",
        url: `/api/setting-management/ColorConfigurationSetting`,
      },
      { apiName: "default" }
    );

  postColorConfigurationSetting = (input: ColorConfigurationSetting) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: "/api/setting-management/ColorConfigurationSetting",
        body: input,
      },
      { apiName: "default" }
    );

  sendEmailPrompt(prompt: string): Observable<string> {
    const payload = { prompt };
    return this.http.post<string>(this.apiUrl, payload, {
      responseType: "text" as "json", // Expect plain text instead of JSON
    });
  }

  sendUploadedDocumentForSign = (
    file: File,
    input: SendUploadedDocumentForSignDto
  ) =>
    this.restService.request<any, any>(
      {
        method: "POST",
        url: "/api/crm-service/document/send-uploaded-document-for-sign",
        body: this.generateSendUploadDocumentation(file, input),
      },
      { apiName: "Default" }
    );

  private generateSendUploadDocumentation(file, input) {
    const formData = new FormData();
    if (file) {
      formData.append("file", file, file.name);
      formData.append("email", input.email ? input.email : "");
      formData.append("documentTitle", input.documentTitle);
    }
    return formData;
  }

  insertAttechDocumentByInput = (input: InserAttechDocumentDto, data: File) =>
    this.restService.request<any, boolean>(
      {
        method: "POST",
        url: '/api/crm-service/attachment/attech-document',
        body: this.generateFileProvider(input, data),
      },
      { apiName: "default" }
    );

  private generateFileProvider(input: InserAttechDocumentDto, file) {
    const formData = new FormData();
    if (file != null) {
      formData.append("leadId", "" + input.leadId);
      formData.append("reason", "" + input.reason);
      formData.append("iFileProvider", file, file.name);
    }
    return formData;
  }

  signedDocumentFileProvider = (input: LeadUsingTemplateTitleAndUpalodTypeDto, data: File) =>
    this.restService.request<any, CRMDocumentResponseDto>(
      {
        method: "POST",
        url: '/api/crm-service/document/send-document-to-lead-using-template-title-and-upload-type',
        body: this.signedDocumentFile(input, data),
      },
      { apiName: "default" }
    );

  private signedDocumentFile(input: LeadUsingTemplateTitleAndUpalodTypeDto, file) {
    const formData = new FormData();
    if (file != null) {
      formData.append("leadId", "" + input.leadId);
      formData.append("templateTitle", "" + input.templateTitle);
      formData.append("sendType", "" + input.sendType);
      formData.append("languages", "" + input.languages);
      formData.append("year", "" + input.year);
      formData.append("documentType", "" + input.documentType);
      formData.append("documentTitle", "" + input.documentTitle);
      formData.append("deliveryMethod", "" + input.deliveryMethod);
      formData.append("reason", "" + input.reason);
      formData.append("iFileProvider", file, file.name);
      // formData.append("email", "" + input.email);
    } else {
      formData.append("leadId", "" + input.leadId);
      formData.append("templateTitle", "" + input.templateTitle);
      formData.append("sendType", "" + input.sendType);
      formData.append("languages", "" + input.languages);
      formData.append("reason", "" + input.reason);
      formData.append("year", "" + input.year);
      formData.append("documentType", "" + input.documentType);
      formData.append("documentTitle", "" + input.documentTitle);
      formData.append("deliveryMethod", "" + input.deliveryMethod);
      // formData.append("email", "" + input.email);
    }
    return formData;
  }

  createNote = (input: CreateNoteDto, File: File[]) =>
    this.restService.request<any, CRMDocumentResponseDto>(
      {
        method: "POST",
        url: '/api/crm-service/notes',
        body: this.noteAttachedFile(input, File),
      },
      { apiName: "default" }
    );

  private noteAttachedFile(input: CreateNoteDto, File: File[]) {
    const formData = new FormData();
    formData.append("leadId", "" + input.leadId);
    formData.append("noteTitle", "" + input.noteTitle);
    formData.append("notesDetails", "" + input.notesDetails);
    if (File && File?.length > 0) {
      for (let i = 0; i < File.length; i++) {
        formData.append(`iFileProvider`, File[i]);
      }
    }
    return formData;
  }

  editNote = (id: any, input: UpdateNoteDto, File: File[]) =>
    this.restService.request<any, CRMDocumentResponseDto>(
      {
        method: "PUT",
        url: `/api/crm-service/notes/${id}`,
        body: this.editnoteAttachedFile(input, File),
      },
      { apiName: "default" }
    );

  private editnoteAttachedFile(input: UpdateNoteDto, File: File[]) {
    const formData = new FormData();
    formData.append("noteTitle", "" + input.noteTitle);
    formData.append("notesDetails", "" + input.notesDetails);
    if (File && File?.length > 0) {
      for (let i = 0; i < File.length; i++) {
        formData.append(`iFileProvider`, File[i]);
      }
    }

    return formData;
  }

  getloginHistory = (input: PagedAndSortedResultRequestDto) =>
    this.restService.request<any, any>(
      {
        method: 'GET',
        url: `/api/identity-server/login-history/login-history`,
        params: {
          sorting: input.sorting,
          skipCount: input.skipCount,
          maxResultCount: input.maxResultCount,
        },
      },
      { apiName: "default" }
    );

  getAddress(id: any) {
    const url = `https://api.addresszen.com/v1/autocomplete/addresses?api_key=${this.addressService.addressKey}&q=${id}`;
    return this.http.get<any>(url);
  }

  getAddressById(id: any) {
    const url = `https://api.addresszen.com/v1/autocomplete/addresses/${id}/usa?api_key=${this.addressService.addressKey}`;
    return this.http.get<any>(url);
  }

  saveDraftChanges = (input: EmailDraftDto, files: File[]) =>
    this.restService.request<any, any>(
      {
        method: 'POST',
        url: `/api/crm-service/email-draft/save-draft-changes`,

        body: this.saveDraftMailByDraftId(input, files),
      },
      { apiName: "default" }
    );

  private saveDraftMailByDraftId(input: EmailDraftDto, files?: File[]) {
    const formData = new FormData();

    formData.append('draftId', input.draftId ? input.draftId.toString() : '0');
    formData.append('subject', input.subject ?? '');
    formData.append('body', input.body ?? '');
    formData.append('toRecipients', input.toRecipients ?? '');
    formData.append('ccRecipients', input.ccRecipients ?? '');
    formData.append('bccRecipients', input.bccRecipients ?? '');
    formData.append('templateId', input.templateId ? input.templateId.toString() : '');
    formData.append('scheduleAt', input.scheduleAt ? input.scheduleAt.toString() : '');
    formData.append('scheduleDate', input.scheduleDate ?? '');
    formData.append('userTimeZone', input.userTimeZone ?? '');
    formData.append('leadId', input.leadId ? input.leadId.toString() : '');

    if (files && files.length > 0) {
      for (const element of files) {
        formData.append('attachments', element);
      }
    }

    return formData;
  }

  updatebyCommunicationTemplateDocument = (
    id: number,
    input: CreateTemplateDocumentDto,
    file: any
  ) =>
    this.restService.request<any, boolean>(
      {
        method: 'PUT',
        url: `/api/coredata-service/template-document/${id}`,

        body: this.generateUpdatedCommunicationTemplateDocument(input, file),
      },
      { apiName: "default" }

    );

  private generateUpdatedCommunicationTemplateDocument(input: CreateTemplateDocumentDto, file) {
    const formData = new FormData();
    if (!input.templateDocument && !input.emailTemplateId) {
      formData.append('emailTemplateId', '');
      formData.append('templateDocument', '');
    } else if (input.templateDocument && !input.emailTemplateId) {
      formData.append('emailTemplateId', '');
      formData.append('templateDocument', file, file.name);
    } else if (!input.templateDocument && input.emailTemplateId) {
      formData.append('emailTemplateId', '' + input.emailTemplateId);
      formData.append('templateDocument', '');
    } else {
      formData.append('emailTemplateId', '' + input.emailTemplateId);
      formData.append('templateDocument', file, file.name);
    }
    return formData;
  }

  insertbyCommunicationTemplateDocument = (input: CreateTemplateDocumentDto, data: File) =>
    this.restService.request<any, boolean>(
      {
        method: 'POST',
        url: '/api/crm-service/template-document',

        body: this.generateCommunicationTemplateDocument(data, input),
      },
      { apiName: "default" }
    );

  private generateCommunicationTemplateDocument(data, input: CreateTemplateDocumentDto) {
    const formData = new FormData();
    if (!input.emailTemplateId && data) {
      formData.append('emailTemplateId', '' + '');
      formData.append('templateDocument', data, data.name);
    } else if (input.emailTemplateId && data) {
      formData.append('emailTemplateId', '' + input.emailTemplateId);
      formData.append('templateDocument', data, data.name);
    }
    return formData;
  }


  private readonly apiUrl = "https://email-ai.jollywater-cf68a1ff.westus2.azurecontainerapps.io/emailsuggestion";

  constructor(private readonly restService: RestService, private readonly http: HttpClient,
    private readonly addressService: AddressKeyService
  ) { }
}
